export const firstCharacterName = (firstName, lastName) => {
  const first = firstName?.trim().charAt(0).toUpperCase() || "";
  const last = lastName?.trim().charAt(0).toUpperCase() || "";
  return first + last;
};

export const CharacterName = (name) => {
  const name1 = name?.trim().charAt(0).toUpperCase() || "";

  return name1;
};
